import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Spinner from "js/react/components/Spinner";
import { FetchStatus } from "js/react/constants";
import ErrorMessage from "js/react/components/ErrorMessage";
import LinkViews from "../Components/LinkViews";
import { LinkStats } from "../Components/Stats";
import linkDS, {
    LinkType
} from "js/react/views/PresentationSettings/dataservices/LinkDataService";
import {
    UIPane,
    UIPaneContents,
    UIPaneHeader
} from "js/react/components/UiComponents";
import AnalyticsController from "js/react/views/Analytics/AnalyticsController";

class LinkAnalyticsPane extends Component {
    componentDidMount() {
        AnalyticsController.fetchLinkAnalytics();
    }

    handleBackButton() {
        // don't set active user to null or animation will crash
        AnalyticsController.clearSelectedLink();
    }

    render() {
        let selectedLink = this.props.analytics.selectedLink;
        let { status } = selectedLink;
        const { t } = this.props;

        return (
            <UIPane className="player_analytics analytics-userpage">
                <UIPaneHeader> {this.renderHeader()}</UIPaneHeader>
                <UIPaneContents>
                    <div className="header-block user-view"></div>
                    <div className="contents-block">
                        {status.type === FetchStatus.LOADING && <Spinner />}
                        {status.type === FetchStatus.ERROR && (
                            <ErrorMessage
                                title={t("An error occurred while loading analytics")}
                                message={status.message}
                            />
                        )}
                        {status.type === FetchStatus.SUCCESS && (
                            <div className="userpage-contents">
                                <LinkStats />
                                <LinkViews />
                            </div>
                        )}
                    </div>
                </UIPaneContents>
            </UIPane>
        );
    }

    renderHeader() {
        const { t } = this.props;
        let selectedLink = this.props.analytics.selectedLink;

        if (selectedLink.linkid) {
            let link = linkDS.getLinkById(this.props.presentation, selectedLink.linkid);

            if (link) {
                let linkName;
                switch (link.get("type")) {
                    case LinkType.PUBLIC:
                        linkName = t("Shareable Link: {{name}}", { name: link.getLinkName() });
                        break;
                    case LinkType.INVITE:
                        linkName = t("Invite Link: {{name}}", { name: link.getLinkName() });
                        break;
                    case LinkType.EMBED:
                        linkName = t("Embedded");
                        break;
                    case LinkType.SOCIAL:
                        linkName = t("Social Link on {{name}}", { name: link.getLinkName() });
                        break;
                    case LinkType.INTEGRATOR:
                        linkName = t("Integration: {{name}}", { name: link.getLinkName() });
                        break;
                }

                return <div className="user-header">{linkName}</div>;
            } else {
                return <div className="user-header">{t("Deleted Link")}</div>;
            }
        } else {
            return <div className="user-header">{t("Link")}</div>;
        }
    }
}

export default AnalyticsController.withState(withTranslation()(LinkAnalyticsPane));
